<template>
    <v-container style="width: 100vmax; max-width: 2500px; position: relative;" class="justify-center pa-0">
        <v-system-bar window color="#006D94">
            <span>AI Dashboard</span>
            <v-spacer></v-spacer>
            <!-- <v-btn icon="mdi-minus" variant="text"></v-btn>-->
            <!--<v-btn icon="mdi-checkbox-blank-outline" variant="text" class="ms-2"></v-btn>-->
            <v-btn icon="mdi-close" variant="text" class="ms-2" @click="close"></v-btn>
        </v-system-bar>
        <v-progress-linear color="#006D94" height="4" indeterminate rounded v-if="loading"></v-progress-linear>

        <v-bottom-sheet v-model="showChatBot" inset>
            <v-card>
                <v-card-text>
                    <br>
                    <br>
                    <v-card class="chat-window w-100">
                        <v-card-text class="chat-content" ref="scrollContainer">
                            <div class="message align-center"
                                :style="{ flexDirection: message.from === 'user' ? 'row-reverse' : 'row' }"
                                v-for="(message, index) in messages" :key="index">
                                <v-avatar class="avatar" v-if="message.from === 'user'">
                                    <div style="display: flex; align-items: center;" v-if="loggedIn">
                                        <small class="mr-2">{{ email }}</small>
                                        <ProfileCircle :name="username" />
                                    </div>
                                </v-avatar>
                                <div :class="`bubble message ${message.from === 'user' ? 'user' : 'bot'}`">
                                    {{ message.text }}
                                </div>
                            </div>
                            <div v-if="isTyping" class="typing-animation">
                                <span v-for="(index, i) in 3" :key="index" class="dot"
                                    :style="{ animationDelay: `${i * 0.3}s`, backgroundColor: i === 1 ? '#333' : '#000' }"></span>
                            </div>
                            <div class="chat-content-divider mt-2"></div>
                        </v-card-text>
                        <v-card-actions>
                            <v-text-field v-model="input" label="Message" append-icon="mdi-send"
                                @click:append="sendMessage" @keyup.enter="sendMessage"
                                class="input-field"></v-text-field>
                        </v-card-actions>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-bottom-sheet>

        <v-container class="ml-0 mr-0 align-center">
            <v-row class="mb-2" v-if="!error">
                <v-col>
                    <v-btn prepend-icon="mdi-comment-processing-outline" variant="flat" color="primary"
                        class="text-capitalize" @click="onChatBot" v-if="!loading && !error">
                        AI Assistant
                    </v-btn>
                </v-col>

            </v-row>
            <v-row>

                <v-container class="ml-0 align-center" fluid style="width: 100%">
                    <v-btn @click="toggleDrag" v-if="!loading && !error">{{ dragEnabled ? 'Done' : 'Adjust Layout' }}</v-btn>
                    <v-alert class="mb-2" variant="outlined" type="error" border="top" v-if="error && !loading">
                        Server Error: Could fetch resources.
                    </v-alert>

                    <draggable v-model="items" tag="div" class="draggable-container" :move="move" @end="updateCharts"
                        :disabled="!dragEnabled">
                        <template #item="{ element }">
                            <div :id="element.i" :key="element.i"
                                :class="['draggable-item', dragEnabled ? 'striped-overlay' : '']" :style="{
                                    cursor: dragEnabled ? 'move' : 'crosshair',
                                    resize: dragEnabled ? 'both' : '',
                                    overflow: dragEnabled ? 'auto' : ''
                                }">
                            </div>
                        </template>
                    </draggable>
                </v-container>
            </v-row>

        </v-container>
    </v-container>
</template>

<script>
import axios from 'axios';
import enigma from 'enigma.js';
import config from '../config.js';
import draggable from 'vuedraggable';
import sdk from '@qlik/sdk';
import stardust from '@nebula.js/stardust';
import barchart from '@nebula.js/sn-bar-chart';
import linechart from '@nebula.js/sn-line-chart';
import table from '@nebula.js/sn-table';
import comboChart from '@nebula.js/sn-combo-chart';
import map from '@nebula.js/sn-map';
import treemap from '@nebula.js/sn-treemap';
import filterpane from '@nebula.js/sn-filter-pane'
import kpi from '@nebula.js/sn-kpi';
import histogram from '@nebula.js/sn-histogram';
import gridchart from '@nebula.js/sn-grid-chart';

export default {
    components: {
        draggable
    },
    data() {
        return {
            input: '',
            dragEnabled: false,
            messages: [],
            loading: true,
            isTyping: false,
            drawer: false,
            selectedChatId: 0,
            chats: [
                //{ id: 0, title: 'Current Chat', started_at: new Date() },
            ],
            showChatBot: false,
            TENANT: config.QLIK_TENANT,
            WEBINTEGRATIONID: config.QLIK_WEBINTEGRATIONID,
            APPID: config.QLIK_APPID_AI,
            SHEETID: config.QLIK_SHEETID_AI,
            error: false,
            username: '',
            email: '',
            items: [
                { i: "chart-container-1" },
                { i: "chart-container-2" },
                { i: "chart-container-3" },
            ],
            to_render: [

            ]
        };
    },
    mounted() {
        document.title = 'TIS AI Dashboard'
        this.main();
    },
    created() {
        this.getUser();
    },
    methods: {
        toggleDrag() {
            this.dragEnabled = !this.dragEnabled;
        },
        move(event) {
            if (!this.dragEnabled) {
                return false;
            }
            return true;
        },
        async getUser() {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Token not found in localStorage');
            }
            const headers = {
                Authorization: `Token ${token}`
            }

            const response = await axios.get(`${config.baseURL}/api/v1/user/me/`, { headers })
            if (response.status == 200) {
                const user_json = response.data
                this.username = user_json.first_name + ' ' + user_json.last_name
                this.email = user_json.email
            }
        },
        close() {
            this.$router.push('/');
        },
        simulateTypingResponse(text) {
            let i = 0;
            const typingSpeed = 10;
            const addChar = () => {
                if (i < text.length) {
                    this.messages.push({ text: text.slice(0, i + 1), from: 'bot' });
                    if (i > 0) this.messages.splice(this.messages.length - 2, 1);
                    i++;
                    this.chatScrollToBottom();
                    setTimeout(addChar, typingSpeed);
                } else {
                    this.isTyping = false;
                }
            };
            setTimeout(addChar, typingSpeed);
        },
        onShare() {
            this.shareLinkCopied = true;
            console.log("onshare");
        },
        onChatBot() {
            this.showChatBot = true;
            this.simulateTypingResponse('How can I help you?');
        },
        chatScrollToBottom() {
            const container = this.$el.getElementsByClassName('chat-content-divider')[0];
            if (container) {
                container.scrollIntoView({ top: 0, behavior: 'smooth' });
            }
        },
        async sendMessage() {
            if (this.input.trim() === '') return;

            this.messages.push({ text: this.input, from: 'user' });
            this.chatScrollToBottom();

            const url = `${config.baseURL}/api/v1/bot/`;

            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Token not found in localStorage');
            }

            const headers = {
                headers: {
                    Authorization: `Token ${token}`
                }
            }
            const data = {
                user_message: this.input,
                chat_id: 0,
                email: this.email,
                //chat_title = data.get('chat_title') 
            };

            try {
                this.isTyping = true;
                this.chatScrollToBottom();
                this.input = '';


                const response = await axios.post(url, data, headers);
                this.isTyping = false;
                this.simulateTypingResponse(response.data.message);
                this.chatScrollToBottom();

            } catch (error) {
                this.simulateTypingResponse('There was an error. Please try again...');
                //console.error('Error:', error.response ? error.response.data : error.message);
            }
        },
        async updateCharts() {
            this.render();
        },
        async qlikLogin() {
            const loggedIn = await this.checkLoggedIn();
            if (loggedIn.status !== 200) {

                const response = await axios.get(`${config.baseURL}/api/v1/qlik_jwt/`);

                const loginRes = await this.jwtLogin(response.data.token);

                if (loginRes.status !== 200) {
                    const message = 'Something went wrong while logging in.';
                    alert(message);
                    throw new Error(message);
                }
                const recheckLoggedIn = await this.checkLoggedIn();
                if (recheckLoggedIn.status !== 200) {
                    const message = 'Third-party cookies are not enabled in your browser settings and/or browser mode.';
                    alert(message);
                    throw new Error(message);
                }
            }
            console.log('Logged in!');
            return true;
        },
        async checkLoggedIn() {
            return await fetch(`https://${this.TENANT}/api/v1/users/me`, {
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'qlik-web-integration-id': this.WEBINTEGRATIONID,
                },
            });
        },
        async jwtLogin(token) {
            const authHeader = `Bearer ${token}`;
            return await fetch(`https://${this.TENANT}/login/jwt-session?qlik-web-integration-id=${this.WEBINTEGRATIONID}`, {
                credentials: 'include',
                mode: 'cors',
                method: 'POST',
                headers: {
                    Authorization: authHeader,
                    'qlik-web-integration-id': this.WEBINTEGRATIONID,
                },
            });
        },
        async getQCSHeaders() {
            const response = await fetch(`https://${this.TENANT}/api/v1/csrf-token`, {
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'qlik-web-integration-id': this.WEBINTEGRATIONID,
                },
            });

            const csrfToken = new Map(response.headers).get('qlik-csrf-token');
            return {
                'qlik-web-integration-id': this.WEBINTEGRATIONID,
                'qlik-csrf-token': csrfToken,
            };
        },
        async render() {
            this.items.forEach(item => {
                const element = document.getElementById(item.i);
                if (element) {
                    element.innerHTML = '';
                }
            });

            this.to_render[0].render({
                element: document.getElementById('chart-container-1'),
                id: 'HSPc',
            });

            this.to_render[1].render({
                element: document.getElementById('chart-container-2'),
                id: 'RkmMB',
            });

            this.to_render[2].render({
                element: document.getElementById('chart-container-3'),
                id: 'kwLq',
            });

            /*this.to_render[3].render({
              element: document.getElementById('chart-container-4'),
              id: 'ptDEpVw',
            });
      
            this.to_render[4].render({
              element: document.getElementById('listbox-container'),
              type: 'listbox',
              fields: ['Year', 'Month', 'Day', 'Weekday', 'Date', 'Port'],
            });*/
        },
        async main() {
            this.error = false;
            const tenantUri = `https://${config.QLIK_TENANT}`;
            const webIntegrationId = config.QLIK_WEBINTEGRATIONID;

            const request = async (path, returnJson = true) => {
                const res = await fetch(`${tenantUri}${path}`, {
                    mode: 'cors',
                    credentials: 'include',
                    redirect: 'follow',
                    headers: {
                        'qlik-web-integration-id': webIntegrationId,
                    },
                });
                if (res.status < 200 || res.status >= 400) throw res;
                return returnJson ? res.json() : res;
            };

            try {
                const loggedIn = await this.qlikLogin();
                const res = await request('/api/v1/csrf-token', false);
                const csrfToken = res.headers.get('qlik-csrf-token');
                const apps = await request('/api/v1/items?resourceType=app');

                if (!apps.data.length) {
                    console.error('No apps available');
                    return;
                }

                const appId = apps.data.find(app => app.name === 'AI Monitoring App (Example)')['resourceId'];
                const url = `${tenantUri.replace('https', 'wss')}/app/${appId}?qlik-web-integration-id=${webIntegrationId}&qlik-csrf-token=${csrfToken}`;
                const schema = await (await fetch('https://unpkg.com/enigma.js@2.7.0/schemas/12.612.0.json')).json();

                const session = enigma.create({ url, schema });
                const global = await session.open();
                const app = await global.openDoc(appId);

                const tmap = stardust.embed(app, {
                    types: [
                        {
                            name: 'treemap',
                            load: () => Promise.resolve(treemap),
                        },
                    ],
                });

                this.to_render.push(tmap);

                const histo = stardust.embed(app, {
                    types: [
                        {
                            name: 'histogram',
                            load: () => Promise.resolve(histogram),
                        },
                    ],
                });

                this.to_render.push(histo);

                const line = stardust.embed(app, {
                    types: [
                        {
                            name: 'linechart',
                            load: () => Promise.resolve(linechart),
                        },
                    ],
                });

                this.to_render.push(line);

                /*const nebbie = stardust.embed(app, {
                  types: [
                    {
                      name: 'barchart',
                      load: () => Promise.resolve(barchart),
                    },
                  ],
                });
        
                this.to_render.push(nebbie);
        
                const map = stardust.embed(app, {
                  types: [
                    {
                      name: 'treemap',
                      load: () => Promise.resolve(treemap),
                    },
                  ],
                });
        
                this.to_render.push(map);
        
                const bar2 = stardust.embed(app, {
                  types: [
                    {
                      name: 'barchart',
                      load: () => Promise.resolve(bar2),
                    },
                  ],
                });
        
                this.to_render.push(bar2);
        
        
                const filter = stardust.embed(app, {
                  types: [
                    {
                      name: 'listbox',
                      load: () => Promise.resolve(listbox),
                    },
                  ],
                });
        
                this.to_render.push(filter);*/

                this.render();


            } catch (err) {
                console.error(err);
                this.error = true;
            } finally {
                setTimeout(() => {
                    this.loading = false;
                }, 2000);
            }
        },
    }
};
</script>

<style scoped>
.container {
    align-items: center;
    justify-content: center;
    text-align: center;
}

.draggable-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.draggable-item {
    width: 500px;
    height: 500px;
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.striped-overlay {
    width: 500px;
    /* Breite des divs */
    height: 500px;
    /* Höhe des divs */
    background: linear-gradient(45deg,
            rgba(0, 0, 0, 0.1) 25%,
            transparent 25%,
            transparent 50%,
            rgba(0, 0, 0, 0.1) 50%,
            rgba(0, 0, 0, 0.1) 75%,
            transparent 75%,
            transparent);
    background-size: 40px 40px;
    /* Größe des Musters */
    background-color: rgba(255, 255, 255, 0.15);
    /* Grundfarbe und Transparenz */
}

.chat-window {
    max-height: 600px;
    overflow: hidden;
    overflow-y: auto;
}

.chat-content {
    display: flex;
    flex-direction: column;
    max-height: 450px;
    overflow-y: auto;
}

.message {
    display: flex;
    margin-top: 10px;
    text-align: left;
}

.avatar {
    margin-top: 10px;
    margin-left: 10px;
}

.bubble {
    padding: 10px 20px;
    border-radius: 20px;
    color: white;
    max-width: 60%;
    word-wrap: break-word;
}

.bot {
    background-color: #006D94;
}

.user {
    background-color: #adadad;
}

.input-field {
    width: 100%;
}

.typing-animation {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    margin-left: 10px;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 3px;
    opacity: 0.4;
    animation: typing 1s infinite;
}

@keyframes typing {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-5px);
    }
}
</style>